module.exports = __webpack_public_path__ + "static/media/PBDQHomePage.eb2c1239.png";